import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"; // Note: Added Navigate for clarity
import {
  Dashboard,
  Events,
  Delegates,
  Excels,
  EventCreate,
  EventUpdate,
  DelegatesCreate,
  DelegatesUpdate,
  ExcelsCreate,
  ExcelsUpdate,
} from "./lazy";
import Layout from "./Layout";
import Login from "../pages/login/Login";
// 🚀 NEW IMPORT
import ProtectedRoute from "./ProtectedRoute";

// 🚨 token.js import is no longer needed here, but keeping for reference if logic moves
// import { token } from "../utils/token";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* ------------------------------------------------------------- */}
        {/* PUBLIC ROUTES */}
        {/* We can also protect the login page if the user is already logged in */}
        <Route path="/login" element={<Login />} />
        {/* ------------------------------------------------------------- */}

        {/* ------------------------------------------------------------- */}
        {/* PROTECTED ROUTES */}
        {/* All routes inside <Layout> will now be protected by the wrapper */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          {/* Dashboard and index route */}
          <Route index element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />

          {/* Events Routes */}
          <Route path="events" element={<Events />} />
          <Route path="events/create" element={<EventCreate />} />
          <Route path="events/update/:id" element={<EventUpdate />} />

          {/* Delegates Routes */}
          <Route path="delegates" element={<Delegates />} />
          <Route path="delegates/create" element={<DelegatesCreate />} />
          <Route path="delegates/update/:id" element={<DelegatesUpdate />} />

          {/* Excels Routes */}
          <Route path="excels" element={<Excels />} />
          <Route path="excels/create" element={<ExcelsCreate />} />
          <Route path="excels/:id" element={<ExcelsUpdate />} />
        </Route>

        {/* Optional: Fallback for 404 - redirects to dashboard if logged in, or login if not */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
